
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import WebhookMixin from '~/mixins/webhookMixin'

export default defineComponent({
  name: 'EnableWebhookEndpoint',
  mixins: [WebhookMixin, ActiveUserMixin],
  data() {
    return {
      enabling: false,
      showEnableModal: false
    }
  },
  computed: {
    testPayload(): string {
      return `{
        "id": "370847944204618991",
        "type": "test.event",
        "createdAt": 1642070207,
        "data": {
          "test": true
        }
      }`
    }
  },
  methods: {
    toggleModal(): void {
      this.showEnableModal = !this.showEnableModal
    },
    async sendTestPayload(close: () => void): Promise<void> {
      const { webhookId } = this.$route.params
      this.enabling = true
      try {
        const response = await this.testEndpoint({ webhookId })
        if (response.ok) {
          await this.fetchSingleEndpoint({ webhookId, refetch: true })
          await this.refetchEndpointList()
          this.$emit('reset')
          this.$toast.success('Successfully enabled the webhook.')
          close()
        } else {
          throw new Error(
            'Unable to enable the webhook endpoint. If this issue persists, contact support.'
          )
        }
      } catch (e) {
        const err = e as Error
        this.$toast.danger(`${err.message.replace('GraphQL error: ', '')}.`)
      } finally {
        this.enabling = false
      }
    },
    close(): void {
      this.showEnableModal = false
    }
  }
})
